module.exports = __webpack_public_path__ + "img/BananaSplit.276de72b.webp";